import { render, staticRenderFns } from "./FooterMinimal.vue?vue&type=template&id=65f675f4&scoped=true&"
import script from "./FooterMinimal.vue?vue&type=script&lang=js&"
export * from "./FooterMinimal.vue?vue&type=script&lang=js&"
import style0 from "./FooterMinimal.vue?vue&type=style&index=0&id=65f675f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f675f4",
  null
  
)

export default component.exports